mama-form-gender {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  z-index: 3;

  mama-form-textfield {
    display: none;
  }

  .title-select,
  .row {
    width: 100%;
  }

  &.show-own-input {
    .title-select {
      display: none;
    }

    mama-form-textfield {
      display: block;
    }
  }
}
